// src/services/authorService.js
import api from './api';

// Retrieve all authors
export const getAuthors = async () => {
  try {
    const response = await api.get('/authors');
    return response.data || [];
  } catch (error) {
    console.error('Error in getAuthors:', error);
    throw error;
  }
};

// Retrieve an author by ID
export const getAuthorById = async (id) => {
  try {
    const response = await api.get(`/authors/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error in getAuthorById:', error);
    throw error;
  }
};

// Create a new author
export const createAuthor = async (authorData) => {
  try {
    const response = await api.post('/authors', authorData);
    return response.data;
  } catch (error) {
    console.error('Error in createAuthor:', error);
    throw error;
  }
};

// Update an existing author by ID
export const updateAuthor = async (id, authorData) => {
  try {
    await api.put(`/authors/${id}`, authorData);
  } catch (error) {
    console.error('Error in updateAuthor:', error);
    throw error;
  }
};

// Delete an author by ID
export const deleteAuthor = async (id) => {
  try {
    await api.delete(`/authors/${id}`);
  } catch (error) {
    console.error('Error in deleteAuthor:', error);
    throw error;
  }
};
